export function onTimeout(timeout, callback, scheduler = globalThis) {
  const timeoutId = scheduler.setTimeout(callback, timeout)

  return () => scheduler.clearTimeout(timeoutId)
}
